module.exports = __webpack_public_path__ + "img/upgrade_center_icon2.48992964.png";